namespace Matrix.Visualizer {
    export namespace VisualizerService {
        export const baseUrl = 'Visualizer';

        export declare function Retrieve(request: GraphDataRequest, onSuccess?: (response: GraphDataResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Visualizer/Retrieve"
        }

        [
            'Retrieve'
        ].forEach(x => {
            (<any>VisualizerService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
